import Select from '@jetbrains/ring-ui/components/select/select'
import React from 'react'

import EditSettingsForm from '../../../../../EditSettingsForm/EditSettingsForm'

import {
  currentTimeZone,
  daysOfWeek as daysOfWeekConstant,
  defaultHour,
  defaultMinute,
  timeZoneList,
} from './JobTriggerForm.consts'
import useJobTriggerForm from './JobTriggerForm.hooks'
import type {JobTriggerFormProps} from './JobTriggerForm.types'

import styles from './JobTriggerForm.css'

import Input, {Size} from 'src/components/pages/PipelinesPages/components/common/Input'

function JobTriggerForm({
  hour = defaultHour,
  minute = defaultMinute,
  daysOfWeek = [],
  timezone = currentTimeZone,
  onApply,
  onCancel,
  onDelete,
}: JobTriggerFormProps) {
  const defaultTime = `${hour}:${minute}`
  const {
    handlerTimeZoneChange,
    handlerDayChange,
    handlerApplyChangesClick,
    timeZoneSelected,
    inputTimeRef,
    selectedDaysOfWeek,
  } = useJobTriggerForm(onApply, daysOfWeek, timezone)

  return (
    <EditSettingsForm
      onConfirmClick={handlerApplyChangesClick}
      onCancelClick={onCancel}
      onDeleteClick={onDelete}
    >
      <div className={styles.content}>
        <Select
          label="Select day"
          multiple={{
            selectAll: true,
            selectAllLabel: 'Every day',
          }}
          size={Size.AUTO}
          onChange={handlerDayChange}
          selected={selectedDaysOfWeek}
          data={daysOfWeekConstant}
        />
        <div className={styles.timeSettings}>
          <Input
            label="Time"
            size={Size.AUTO}
            defaultValue={defaultTime}
            inputRef={inputTimeRef}
            inputClassName={styles.inputTime}
            type="time"
          />
          <div className={styles.selectTimeZoneWrapper}>
            <Select
              selectedLabel="Time zone"
              label="Select time zone"
              clear
              filter
              className={styles.selectTimeZone}
              size={Size.AUTO}
              onChange={handlerTimeZoneChange}
              selected={timeZoneSelected}
              data={timeZoneList}
            />
          </div>
        </div>
      </div>
    </EditSettingsForm>
  )
}

export default JobTriggerForm
